// extracted by mini-css-extract-plugin
export default {"columnSpace":"Calculations_columnSpace__-1WRY","wrongSoilLayers":"Calculations_wrongSoilLayers__V2RXK","p":"Calculations_p__M5yYo"};